package data.repository

import domain.model.ActionCard
import domain.repository.ActionRepository
import data.datasource.ActionLocalDataSource

class ActionRepositoryImpl(
    private val localDataSource: ActionLocalDataSource
) : ActionRepository {
    
    private var cachedActions: List<ActionCard>? = null
    
    override fun getActions(): List<ActionCard> {
        if (cachedActions == null) {
            cachedActions = localDataSource.getActions()
        }
        return cachedActions ?: emptyList()
    }
    
    override fun saveActions(actions: List<ActionCard>) {
        cachedActions = actions
        localDataSource.saveActions(actions)
    }
    
    override fun addAction(action: ActionCard) {
        val currentActions = getActions().toMutableList()
        currentActions.add(action)
        saveActions(currentActions)
    }
    
    override fun removeAction(actionId: String) {
        val currentActions = getActions().toMutableList()
        currentActions.removeAll { it.id == actionId }
        saveActions(currentActions)
    }
}
